import { HTMLAttributes } from "react";

export default function IconGrowthPath1(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="uuid-cdb2f8da-05c4-40f8-b839-5e2b247fc6e8"
      data-name="Layer 2"
      viewBox="0 0 59.484 59.484"
      {...props}
    >
      <defs>
        <style>
          {
            ".uuid-2d3a52da-e6d4-43d7-9b36-8c1f41089d9a{fill:none;stroke:var(--color-primary);stroke-width:3px;stroke-linecap:round;stroke-linejoin:round}"
          }
        </style>
      </defs>
      <g id="uuid-9be25681-9370-4fed-a539-81ef4d9eb24c" data-name="Layer 1">
        <g id="uuid-5265a3dd-2722-4186-8ec9-f0ea9e40b2e0" data-name="g4485">
          <g id="uuid-8b39fd71-d3da-43c8-b8c0-dd9680f97d4a" data-name="g4487">
            <g id="uuid-14ceb991-895b-4e12-acd1-4d2ee507673e" data-name="g4489">
              <g
                id="uuid-fd171788-d2c0-4b96-bac4-cb084da0cfbe"
                data-name="g4495"
              >
                <path
                  id="uuid-ba0750b3-e3df-4567-a5e4-e1638a0b26b8"
                  d="M15.563 29.625H1.5V19.078a7.031 7.031 0 1 1 14.062 0v10.547Z"
                  className="uuid-2d3a52da-e6d4-43d7-9b36-8c1f41089d9a"
                  data-name="path4497"
                />
              </g>
              <g
                id="uuid-1e36c96c-eb69-45b6-af90-bfd41b3132b0"
                data-name="g4499"
              >
                <path
                  id="uuid-d60525f8-a64d-4e5f-baa6-d03abdda6b0c"
                  d="M12.047 50.953V29.625"
                  className="uuid-2d3a52da-e6d4-43d7-9b36-8c1f41089d9a"
                  data-name="path4501"
                />
              </g>
              <g
                id="uuid-5526b934-f2e3-4f9d-9999-dc8e4594611b"
                data-name="g4503"
              >
                <path
                  id="uuid-3a963c88-acc2-4446-be61-f60caf7eec8a"
                  d="M5.016 29.625v21.328"
                  className="uuid-2d3a52da-e6d4-43d7-9b36-8c1f41089d9a"
                  data-name="path4505"
                />
              </g>
              <g
                id="uuid-d0e5d623-99dd-4020-ab6a-b86934c41dde"
                data-name="g4507"
              >
                <path
                  id="uuid-82c0d870-2db8-4968-aeec-2ff8923b37a1"
                  d="M12.047 5.016a3.516 3.516 0 1 1-7.031 0 3.516 3.516 0 0 1 7.03 0Z"
                  className="uuid-2d3a52da-e6d4-43d7-9b36-8c1f41089d9a"
                  data-name="path4509"
                />
              </g>
              <g
                id="uuid-2c65d4f3-f8c8-4e71-91aa-14c7e329ed17"
                data-name="g4511"
              >
                <path
                  id="uuid-ed556d08-ed11-43a6-9bde-4935c4f6bf08"
                  d="M57.984 19.313H47.437v10.546h-14.18v10.547H19.079v10.547H1.5v7.031h56.484V19.312Z"
                  data-name="path4513"
                  style={{
                    fill: "none",
                    stroke: "var(--color-primary)",
                    strokeWidth: 3,
                    strokeMiterlimit: 13.3333,
                  }}
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
